/* eslint-disable no-underscore-dangle */
import { v4 as uuidv4 } from 'uuid';
import { format, formatDistance } from 'date-fns';

import { ValueOf } from '../../globalTypes';
import { LAST_CHANGE_TIME_FORMAT } from '../../constants';
import constants from './constants';

type UploadStatus = ValueOf<typeof constants.UPLOAD_STATUS>;

class UploadToSdFile extends File {
  readonly _id: string;

  private _uploadedAt: Date | null;

  private _status: UploadStatus;

  constructor(file: File) {
    super([file], file.name, { type: file.type });

    this._id = uuidv4();
    this._uploadedAt = null;
    this._status = constants.UPLOAD_STATUS.UPLOADING;
  }

  get id(): string {
    return this._id;
  }

  get uploadedAt(): Date | null {
    return this._uploadedAt;
  }

  get status(): UploadStatus {
    return this._status;
  }

  set status(status: UploadStatus) {
    if (status === constants.UPLOAD_STATUS.UPLOADED) {
      this._uploadedAt = new Date();
    }

    this._status = status;
  }

  getDatePrettyLabel(): string {
    if (this.uploadedAt) {
      return format(this.uploadedAt, LAST_CHANGE_TIME_FORMAT);
    }

    return '';
  }

  getRelativeDatePrettyLabel(): string {
    if (this.uploadedAt) {
      return `${formatDistance(this.uploadedAt, new Date())} ago`;
    }

    return '';
  }
}
// trick: create interface with the same name as a class above so we don't
// need to redeclare the members
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface UploadToSdFile extends File {}

export default {
  UploadToSdFile,
};
export type {
  UploadToSdFile,
};
